// Fallback views: unknown route, document that does not exist, loading placeholder.
import { Icon } from '../components/Icon';
import { Link } from '../components/NavGuard';

export function PageLoading() {
  return (
    <div className="page page--center" aria-busy="true">
      <p className="muted loading-line">
        <Icon name="spinner" size={20} /> Nalagam …
      </p>
    </div>
  );
}

export function DocumentMissing({ error, onRetry }: { error: string | null; onRetry: () => void }) {
  return (
    <div className="page page--center">
      <div className="card empty-card">
        <Icon name={error ? 'cloudOff' : 'file'} size={36} className="empty-card__icon" />
        <h1 className="empty-card__title">{error ? 'Dokumenta ni bilo mogoče naložiti' : 'Dokument ne obstaja'}</h1>
        <p className="muted">{error ?? 'Dokument je bil morda izbrisan ali pa povezava ni pravilna.'}</p>
        <div className="empty-card__actions">
          {error && (
            <button type="button" className="btn btn--secondary" onClick={onRetry}>
              <Icon name="refresh" size={20} /> Poskusi znova
            </button>
          )}
          <Link to={{ name: 'home' }} className="btn btn--primary">
            Na začetno stran
          </Link>
        </div>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="page page--center">
      <div className="card empty-card">
        <Icon name="search" size={36} className="empty-card__icon" />
        <h1 className="empty-card__title">Stran ne obstaja</h1>
        <p className="muted">Povezava je morda napačna ali zastarela.</p>
        <div className="empty-card__actions">
          <Link to={{ name: 'home' }} className="btn btn--primary">
            Na začetno stran
          </Link>
        </div>
      </div>
    </div>
  );
}
